import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from 'antd';
import { makeStyles } from '@material-ui/styles';
import generatePath from '~settings/routing';
import { useLazyQuery } from '@apollo/client';
import SpinLoading from 'common/components/spin-loading';
import { useHistory } from 'react-router-dom';
import PendingCheckIn from './pendingCheckIn';
import PendingConfirmation from './pendingConfirmation';
import PendingRefunding from './pendingRefund';
import { QUERY_ORDERS } from './queries';

const IMGSVG = `url("data:image/svg+xml,%3Csvg viewBox='0 0 472 170' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m45.078 75.262 6.746-9.28 6.071 9.28 6.746-9.28 6.072 9.28 6.746-9.28 6.072 9.28v-51.31h26.984V83.88h87.026v85.179H45.078V75.262Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.097 106.462h29.265v31.491H16.097v-31.491Z' fill='%23fff'/%3E%3Cpath d='M197.537 78.458v2.934h-30.24v-2.934c0-3.829 5.703-10.933 15.12-10.933 9.083 0 15.12 7.104 15.12 10.933Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M117.021 95.42H92.958v41.799h40.319v-26.642h-16.256V95.421Z' fill='%23E9E8E6'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M117.654 117.014h3.528v3.782h-3.528v-3.782Zm-7.059 0h3.528v3.782h-3.528v-3.782Zm17.645 0h-3.528v3.782h3.528v-3.782Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M50.116 81.392h3.37v3.782h-3.37v-3.782Zm12.806 0h3.37v3.782h-3.37v-3.782Zm16.176 0h-3.37v3.782h3.37v-3.782ZM92.956 45.157c-1.89 0-2.52 1.891-2.52 1.891v9.455h5.04v-9.455s-.63-1.89-2.52-1.89Zm7.561 0c-1.89 0-2.52 1.891-2.52 1.891v9.455h5.04v-9.455s-.63-1.89-2.52-1.89Z' fill='%23B8D9D0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M92.805 4.469C94.5 3.074 96.043 1.807 96.043 0c0 1.814 1.835 3.1 3.849 4.511 2.448 1.716 5.16 3.616 5.16 6.874 0 2.145-1.085 3.352-2.471 4.019h8.018v6.027h-27.72v-6.027h7.94c-1.352-.673-2.4-1.883-2.4-4.019 0-3.312 2.31-5.21 4.386-6.916Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.504 95.826h29.568l-10.406 10.779H16.097l10.407-10.78Z' fill='%23FFEDE4'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m56.072 95.826 10.71 10.823v31.137h-21.42v-31.137l10.71-10.823Z' fill='%23E7E7E7'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m56.072 95.826 10.71 10.823h-21.42l10.71-10.823Z' fill='%23F8A588'/%3E%3Cellipse cx='182.41' cy='66.891' rx='4.41' ry='1.891' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M172.134 116.69h17.847v-1.409h-19.169l1.322 1.409Zm-5.288-5.636h23.135v-1.409h-24.457l1.322 1.409Zm-5.288-5.636h28.423v-1.409h-29.745l1.322 1.409Zm-5.288-5.636h33.711v-1.409h-35.033l1.322 1.41Zm-5.288-5.635h38.998v-1.41h-40.32l1.322 1.41Z' fill='%23B8D9D0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 124.914h151.447v8.935h8.962l.007 8.934h8.956l.013 8.935h8.949l.021 8.934h8.941l.028 8.935L0 169.691v-44.777Z' fill='%23FFF8DA'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M349.134 153.463a18.777 18.777 0 0 1-1.898-8.255c0-10.405 8.426-18.84 18.821-18.84 3.833 0 7.398 1.147 10.371 3.116a19.182 19.182 0 0 1 11.205-3.591c8.907 0 16.403 6.045 18.617 14.261.22-.011.441-.017.663-.017 7.352 0 13.312 5.966 13.312 13.326h.001v15.623h-71.154v-15.623h.062Z' fill='%23D8E6E2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M415.152 156.537a15.016 15.016 0 0 1-1.51-6.583c0-8.32 6.737-15.063 15.048-15.063 3.06 0 5.906.913 8.281 2.483a15.334 15.334 0 0 1 8.97-2.88c7.121 0 13.115 4.834 14.885 11.402.175-.009.352-.013.53-.013 5.878 0 10.644 4.77 10.644 10.654v12.492h-56.89v-12.492h.042Z' fill='%23ABD9D0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m342.416 31.234 6.197 19.3h-12.394l6.197-19.3Z' fill='%238AA4A8'/%3E%3Cpath fill='%238AA4A8' d='M336.219 51.912h12.395v8.271h-12.395zM332.546 72.13h19.74v96.956h-19.74z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M336.219 61.562h12.394l3.673 9.19h-19.74l3.673-9.19Z' fill='%238AA4A8'/%3E%3Crect x='336.219' y='74.887' width='1.377' height='7.352' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='339.891' y='74.887' width='1.377' height='7.352' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='343.563' y='74.887' width='1.377' height='7.352' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='347.236' y='74.887' width='1.377' height='7.352' rx='.689' fill='%23B8D9D0'/%3E%3Cellipse cx='342.645' cy='92.808' rx='5.968' ry='5.974' fill='%23B8D9D0'/%3E%3Cpath fill='%23fff' d='M303.167 126.625h40.397v2.298h-40.397zM303.167 132.599h40.397v37.22h-40.397z'/%3E%3Crect x='307.297' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='313.265' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='319.692' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='325.66' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='332.088' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Crect x='338.055' y='136.921' width='1.377' height='23.894' rx='.689' fill='%23B8D9D0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M194.931 157.033a14.964 14.964 0 0 1-1.465-6.479c0-8.291 6.715-15.013 14.999-15.013 2.944 0 5.691.85 8.008 2.317a15.288 15.288 0 0 1 9.185-3.049c7.235 0 13.303 5.006 14.933 11.747.263-.02.529-.03.797-.03 5.737 0 10.41 4.558 10.603 10.253h.007v12.45h-57.067v-12.196Z' fill='%23ABD9D0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m462.01 69.847.588 11.637a6.955 6.955 0 0 1 6.542 6.946 6.959 6.959 0 0 1-5.248 6.746l.049 2.708h1.991v1.784h-1.959l.013.714h1.946v1.784h-1.914l1.201 66.951h-6.059l.901-66.951h-1.971v-1.784h1.995l.01-.714h-2.005v-1.784h2.029l.038-2.8a6.96 6.96 0 0 1-4.918-6.654 6.955 6.955 0 0 1 6.182-6.916l.589-11.667Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M298.09 163.258a8.39 8.39 0 0 1-1.462-4.746c0-4.651 3.767-8.422 8.414-8.422a8.37 8.37 0 0 1 4.359 1.217 8.74 8.74 0 0 1 5.515-1.95c4.093 0 7.532 2.804 8.505 6.598a5.856 5.856 0 0 1 6.129 5.852v7.324h-31.46v-5.873Z' fill='%23E4F4F3'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M263.702 107.976h13.901l7.317 12.662v48.021h-28.534v-48.021l7.316-12.662Z' fill='%23E9E8E6'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M262.808 128.383h3.528v3.782h-3.528v-3.782Zm7.057 0h3.528v3.782h-3.528v-3.782Zm10.583 0h-3.528v3.782h3.528v-3.782ZM230.78 169.957H271.019v-6.868l.001-.089-.001-.089v-.129h-.003a6.953 6.953 0 0 0-7.71-6.698c-1.202-4.256-4.991-7.365-9.48-7.365-2.702 0-5.151 1.127-6.934 2.952a9.83 9.83 0 0 0-6.235-2.219c-5.333 0-9.678 4.23-9.871 9.521l-.006-.001v10.985Z' fill='%238AA4A8'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M279.312 134.34h18.86v35.387h-18.86V134.34Z' fill='%23fff'/%3E%3C/svg%3E")`;

const useStyles = makeStyles(theme => {
  return {
    loading: {
      height: '80vh',
    },
    wrapper: {
      minWidth: 500,
      flex: 1,
      marginRight: 16,
    },

    banner: {
      width: '100%',
      position: 'relative',
      padding: '28px 32px',
      backgroundImage: 'none',
      backgroundPosition: 'bottom 0 right 0',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '472px 170px',
      backgroundColor: theme.colors.mainGreen1,

      '@media (min-width: 1336px) and (max-width:1513px)': {
        backgroundImage: IMGSVG,

        backgroundPosition: 'bottom 0 right -210px',
      },

      '@media (min-width: 1514px )': {
        backgroundImage: IMGSVG,

        backgroundPosition: 'bottom 0 right 0px',
      },
    },
    bannerTitle: {
      color: theme.colors.mainGreen6,
      fontWeight: 600,
    },
    btn: {
      fontWeight: 600,
    },
    bannerH2: {
      ...theme.typography.h2,
      marginTop: 16,
      marginBottom: 8,
    },

    row: {
      background: theme.colors.gray1,
      marginTop: 16,
      paddingLeft: 24,
      paddingTop: 16,
    },
  };
});
const HerculesOperationsPage = props => {
  const { t } = useTranslation();

  const classes = useStyles();
  const { Text } = Typography;
  const history = useHistory();
  const [queryOrder, { data: orders, loading, refetch: reftchOrders }] = useLazyQuery(
    QUERY_ORDERS,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      onError: e => {
        message.error(e.toString());
      },
    },
  );

  const updateOrder = data => data?.viewer?.company;
  const orderInfo = useMemo(() => {
    return updateOrder(orders);
  }, [orders]);
  useEffect(() => {
    queryOrder();
  }, []);
  const {
    pendingConfirmation = { totalCount: 0, edges: [], pageInfo: { hasNextPage: false } },
    pendingRefundOrder = { totalCount: 0, edges: [] },
    pendingCheckInOrder = { totalCount: 0, edges: [] },
  } = orderInfo || {};

  const Banner = () => {
    return (
      <div>
        <div className={classes.banner}>
          <Text className={classes.bannerTitle}>{t('board.banner.first_title')} </Text>
          <h2 className={classes.bannerH2}>{t('board.banner.h2')}</h2>
          <Text> {t('board.banner.desc')}</Text>
          <div style={{ marginTop: '24px', marginBottom: '0' }}>
            <Button
              size="large"
              type="primary"
              onClick={() => {
                history.push(generatePath('propertiesList'));
              }}
              className={classes.btn}
            >
              {t('board.publish_property_btn')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.wrapper}>
      <Choose>
        <When condition={loading}>
          <SpinLoading className={classes.loading} />
        </When>
        <When condition={!!orders}>
          <Banner />
          <PendingConfirmation order={pendingConfirmation} refetchData={reftchOrders} />

          <PendingCheckIn order={pendingCheckInOrder} />
          <If condition={!!pendingRefundOrder?.edges?.length}>
            <PendingRefunding order={pendingRefundOrder} />
          </If>
        </When>
      </Choose>
    </div>
  );
};

export default HerculesOperationsPage;
